<template>
    <header class="main-header">
        <div class="main-header-bar">
            <div class="main-header-logo">
                TECH SCHOOL
            </div>
            <div class="main-header-nav">
                <ul class="main-header-nav-list">
                    
                    <li class="main-header-item">エンジニア転職</li>
                    <li class="main-header-item">デザイナー転職</li>
                    <li class="main-header-item">目的別</li>
                    <li class="main-header-item">法人のお客様</li>
                    <li class="main-header-item">
                        <div class="btn secondary-btn">無料カウンセリング</div>
                    </li>
                </ul>
            </div>
            <ul class="main-header-nav-sp hide-pc">
                <li class="main-header-item-sp">
                    <div class="btn secondary-btn">無料カウンセリング</div>
                </li>
                    
            </ul>
            <a class="humburger-btn hide-pc js-close js-header-menu">
                <span></span>
            </a>
            
        </div>
    </header>
</template>

<script>
export default {
    name: 'Header'
}
</script>

<style scoped>
 .main-header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    padding: 15px 20px;
    z-index: 1000;
    height: 68px;
 }

 .main-header-logo {
     margin-left: 30px;
     padding:0;
     vertical-align: middle;
     line-height: 68px;
     font-size: 30px;

 }

 .main-header-item {
     padding: 10px;
     font-size: .9rem;
     /* line-height: 48px; */
 }

 .main-header-nav {
     margin-right: 10px;
 }
 
 .main-header-bar {
     display: flex;
     position: relative;
     background-color: #fff;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 10px;
    height: 100%;
    box-shadow: 0 0 24px rgba(0,0,0,0.2);
 }

.secondary-btn {
    color: #FFF;
    background-color: #ef2828;
    padding:0 25px;
    border-radius: 24px;
}

 ul {
     height: 100%;
     margin: 0;
     /* margin-top: 12px; */
 }

 li {
     line-height: 48px;
 }

 .main-header-nav-list {
     display: flex;
 }

 @media screen and (max-width: 767px){

     .main-header-logo h1 {
        display: flex;
        justify-items: center;
        font-size: 3.5vw;
        margin-left: 0px;
        line-height: 48px;
        vertical-align: middle;
    }


     .main-header-nav {
         display: none;
     }

     .btn {
        margin: 8px 0;
        padding: 0 14px;
        font-size: .7rem;
        line-height: 44px;
        border-radius: 5px;
     }

     .main-header-bar {
         height: 60px;
         padding: 0 15px;
        border-radius: 6px;
        box-shadow: 0 0 12px rgba(0,0,0,0.1);
     }

     .humburger-btn {
        display: block;
        position: absolute;
        right: 5px;
        padding: 29px 15px;
     }

     .humburger-btn span {
        position: relative;
        width: 20px;
        height: 2px;
        background-color: #212121;
        border-radius: 1.5px;
        display: block;
        transition: all .2s ease-out;
     }

    .humburger-btn span:before {
        content: "";
        display: block;
        position: absolute;
        top: -8px;
        left: 0;
        width: 20px;
        height: 2px;
        background-color: #212121;
        border-radius: 1.5px;
        transition: all .2s ease-out;
     }

     .humburger-btn span:after {
        content: "";
        display: block;
        position: absolute;
        top: 8px;
        left: 0;
        width: 20px;
        height: 2px;
        background-color: #212121;
        border-radius: 1.5px;
        transition: all .2s ease-out;
     }

     .main-header-nav-sp {
         display: flex;
         margin-right: 40px;
         align-items: center;
     }
 }
</style>